<template>
	<span v-if="item" class="logo"
		  :class="componentClass" :title="finalTitle">
		<v-avatar :size="size"
				  :rounded="rounded"
				  :class="componentClass" color="orange lighten-4">
			<v-img v-if="item.image" :src="item.image?.srcThumb" :lazy-src="item.image?.srcLazy"/>
			<v-img v-else-if="item.isPersonal" src="@/assets/1task-logo.png"/>
			<span v-else class="logo__fi">{{ fi }}</span>
		</v-avatar>
		<div v-if="icon" class="logo__icon" :class="iconClass">
			<v-icon color="white">{{ icon }}</v-icon>
		</div>
	</span>
</template>

<script>
import * as userUtils from "@/utils/user";

export default {
	name: "avatar",
	props: {
		item: {},
		small: {
			type: Boolean,
			default: false,
		},
		large: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: null,
		},
		icon: {
			type: String,
			default: null,
		},
		iconColor: {
			type: String,
			default: null,
		},
	},
	data: () => ({}),
	computed: {
		finalTitle() {
			return this.title || this.name;
		},
		rounded() {
			return true;//!!this.item.withTopics;
		},
		size() {
			if (this.large) return 32;
			if (this.small) return 22;
			return 24;
		},
		fi() {
			return userUtils.fi(this.item);
		},
		componentClass() {
			const c = [];
			if (this.small) c.push("--small");
			return c?.length > 0 ? c : null;
		},
		iconClass() {
			const c = [];
			if (this.iconColor) c.push(this.iconColor);
			else c.push("grey");

			return c?.length > 0 ? c : null;
		}
	}
}
</script>

<style lang="scss">
.logo {
	position: relative;
	text-transform: uppercase;

	&__fi {
		font-size: .55rem;
	}

	&__icon {
		position: absolute;
		z-index: 1;
		right: -4px;
		bottom: -4px;
		width: 14px;
		height: 14px;
		//border-radius: 50%;
		border-radius: 5px;
		background-color: map-get($red, "lighten-1");
		display: flex;
		align-items: center;
		justify-content: center;

		.v-icon {
			font-size: 10px !important;
		}
	}
}
</style>